module.exports = "<p>\r\n  sonuc works!\r\n</p>\r\n"